// extracted by mini-css-extract-plugin
export default {"SingleSignOnCard":"P7YWZEAZJ0","ProviderImage":"YUMsq6CJMc","SingleSignOnCard__contained":"ZPf_dW4xJy"};